import { apiService } from '../api';
import { ApiResponse, PaginatedResponse } from '../../types/api';
import { AccountFilters, AccountMatch } from '../../types/account';
import type { Account, CreateAccountRequest, UpdateAccountRequest, Client } from '../../types/api';

class AccountService {
  async getAccounts(params?: AccountFilters): Promise<PaginatedResponse<Account>> {
    // Convert AccountFilters to apiService compatible parameters.
    // Whitelist mirrors the backend filter list in AccountController::index().
    // (user_id and unassigned were previously dropped here — bug fix.)
    const apiParams = params ? {
      page: params.page,
      per_page: params.per_page,
      search: params.search,
      status: params.status,
      client_id: params.client_id,
      user_id: params.user_id,
      unassigned: params.unassigned,
      no_employees: params.no_employees,
    } : undefined;

    return await apiService.getAccounts(apiParams);
  }

  async getAccount(id: number): Promise<ApiResponse<Account>> {
    return await apiService.getAccount(id);
  }

  async createAccount(data: CreateAccountRequest): Promise<ApiResponse<Account>> {
    return await apiService.createAccount(data);
  }

  async updateAccount(id: number, data: UpdateAccountRequest): Promise<ApiResponse<Account>> {
    return await apiService.updateAccount(id, data);
  }

  async deleteAccount(id: number, force = false): Promise<ApiResponse<any>> {
    return await apiService.deleteAccount(id, force);
  }

  async toggleAccountStatus(id: number): Promise<ApiResponse<Account>> {
    return await apiService.toggleAccountStatus(id);
  }

  async getAvailableClients(): Promise<ApiResponse<Client[]>> {
    return await apiService.getAvailableClients();
  }

  async getAccountMatches(accountId: number): Promise<ApiResponse<AccountMatch[]>> {
    return await apiService.getAccountMatches(accountId);
  }

  async bulkAssignEmployees(
    accountIds: number[],
    employees: Array<{ user_id: number; commission_percentage: number }>,
    overwriteExisting: boolean
  ): Promise<ApiResponse<any>> {
    return await apiService.bulkAssignEmployeesToAccounts({
      account_ids: accountIds,
      employees,
      overwrite_existing: overwriteExisting
    });
  }
}

export const accountService = new AccountService();
export default accountService;